<template>
  <O3D>
    <O3D>
      <!-- <O3D :px="0" :pz="10" :py="50">
        <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
      </O3D>

      <O3D :px="0" :pz="-10" :py="18">
        <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
      </O3D>

      <O3D :px="25" :pz="25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="-25" :pz="25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="25" :pz="-25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="-25" :pz="-25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D> -->

      <O3D :px="0" :pz="0" :py="1000">
        <DirectionalLight :color="0xffffff" :floorColor="0xffffff" :helper="isDev && isOff" :intensity="0.5"></DirectionalLight>
      </O3D>

      <O3D :px="0" :pz="0" :py="0">
        <AmbinetLight :color="0xffffff" :helper="isDev && isOff" :intensity="0.75"></AmbinetLight>
      </O3D>
    </O3D>
    <!-- <CitySky></CitySky> -->
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'

export default {
  mixins: [O3DG2],
  mounted () {
  },
  methods: {
    setup (o3d) {
      console.log(o3d)
    }
  }
}
</script>

<style>
</style>
